import React from 'react';

import { BaseMotionTokenTable, type MotionTokenTableValue } from '../base-table';

const values: MotionTokenTableValue[] = [
	{
		tokenName: 'motion.flag.reposition',
		component: 'Flag',
	},
	{
		tokenName: 'motion.avatar.enter',
		component: 'Avatar group',
	},
	{
		tokenName: 'motion.avatar.exit',
	},
	{
		tokenName: 'motion.blanket.enter',
		component: 'Modal',
	},
	{
		tokenName: 'motion.blanket.exit',
	},
	{
		tokenName: 'motion.flag.enter',
		component: 'Flag',
	},
	{
		tokenName: 'motion.flag.exit',
	},
	{
		tokenName: 'motion.modal.enter',
		component: 'Modal',
	},
	{
		tokenName: 'motion.modal.exit',
	},
	{
		tokenName: 'motion.popup.enter.top',
		component: 'Popup, Dropdown, Inline message',
	},
	{
		tokenName: 'motion.popup.enter.bottom',
	},
	{
		tokenName: 'motion.popup.enter.left',
	},
	{
		tokenName: 'motion.popup.enter.right',
	},
	{
		tokenName: 'motion.popup.exit.top',
	},
	{
		tokenName: 'motion.popup.exit.bottom',
	},
	{
		tokenName: 'motion.popup.exit.left',
	},
	{
		tokenName: 'motion.popup.exit.right',
	},
	{
		tokenName: 'motion.tab.indicator.enter.left',
		component: 'Tabs',
	},
	{
		tokenName: 'motion.tab.indicator.enter.right',
	},
	{
		tokenName: 'motion.tab.indicator.exit.left',
	},
	{
		tokenName: 'motion.tab.indicator.exit.right',
	},
	{
		tokenName: 'motion.spotlight.enter',
		component: 'Spotlight',
	},
	{
		tokenName: 'motion.spotlight.exit',
	},
];

/**
 * __Transitions table__
 */
export const MotionTransitionsTable = (): React.JSX.Element => {
	return <BaseMotionTokenTable values={values} testId="motion-transitions-table" />;
};
